import { Observable, Subscription } from "rxjs";

import { appLog } from "@archipad/logs/logger";

/**
 * Logs the network availability and the page lifecycle (hidden, frozen, discarded...),
 * which is what happens to the app when the device goes to sleep.
 *
 * @returns stops the logs when unsubscribed
 */
export function watchNetworkAndPageLifecycle(onlineStatus$: Observable<boolean>): Subscription {
    appLog
        .withMetadata({
            // the tab has been discarded by the browser (e.g. while the device was sleeping) and reloaded
            "archipad.page.was_discarded": Boolean((document as Document & { wasDiscarded?: boolean }).wasDiscarded),
        })
        .info("app.start");

    const subscription = onlineStatus$.subscribe((isOnline) => {
        const connection = (navigator as Navigator & { connection?: { effectiveType?: string } }).connection;
        appLog
            .withMetadata({ "archipad.network.effective_type": connection?.effectiveType })
            .info(isOnline ? "network.online" : "network.offline");
    });

    const onVisibilityChange = () => {
        appLog.info(document.visibilityState === "hidden" ? "page.hidden" : "page.visible");
    };
    const onFreeze = () => appLog.info("page.freeze");
    const onResume = () => appLog.info("page.resume");
    document.addEventListener("visibilitychange", onVisibilityChange);
    document.addEventListener("freeze", onFreeze);
    document.addEventListener("resume", onResume);
    subscription.add(() => {
        document.removeEventListener("visibilitychange", onVisibilityChange);
        document.removeEventListener("freeze", onFreeze);
        document.removeEventListener("resume", onResume);
    });

    return subscription;
}
